import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SensorMapLineComponentPage } from './sensor-map-line-component.page';

const routes: Routes = [
  {
    path: '',
    component: SensorMapLineComponentPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SensorMapLineComponentPageRoutingModule {}
